import CallbackManager from 'data/CallbackManager';


class Channels {

  constructor() {
    this.channelsList = {};
    this.callbackManager = new CallbackManager(this);
  }

  getChannelList() {
    return this.channelsList;
  }

  add(channelId, channel) {
    this.channelsList[channelId] = {channel};
    this.callbackManager.update(this.channelsList);
  }

  remove(channelId) {
    let entry = this.channelsList[channelId];
    if (entry && entry.channel && entry.channel.disconnect) {
      entry.channel.disconnect();
    }
    delete this.channelsList[channelId];
    this.callbackManager.update(this.channelsList);
  }

  update(channelId, updateMillis) {
    this.channelsList[channelId].updateMillis = updateMillis;
    this.callbackManager.update(this.channelsList);
  }
}


Channels.Factory = class {
  create() {
    return _instance;
  }
}


const _instance = new Channels();


export default Channels;

